import { createFileRoute } from '@tanstack/react-router'
import AdminColorsPage from '@/components/pages/Admin/AdminColorsPage/AdminColorsPage'

export const Route = createFileRoute('/$workspaceName/$environment/admin/colors')({
  component: AdminColorsRoute,
})

function AdminColorsRoute() {
  return <AdminColorsPage />
}
